import styles from "./Comecar.module.css";

import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import { Link } from "react-router-dom";

function Comecar() {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <div className={styles.text}>
            <div className={styles.title} data-aos="fade-up">Vamos dar o primeiro passo?</div>
            <div className={styles.divider} data-aos="fade-up"></div>
            <div className={styles.description} data-aos="fade-up">Explore nossa loja de bots e encontre a automação ideal para o seu projeto. Funcionais, acessíveis e prontos pra te levar pro próximo nível.</div>

            <Link to={"/planos"} className={styles.topic} data-aos="fade-up">
                <button>Comece agora</button>
            </Link>
        </div >
    )
}

export default Comecar;